import type { Store } from '@/stores';
import { useMapStoreStateToClientState } from '@/hooks/useMapStoreStateToClientState';

// custom hook to read the props
const useStateOfSearchResultList = (store: Store) => {
  return useMapStoreStateToClientState(store, (store: Store) => ({
    groupedSearchResults: store.appStore.completeSearchPage.groupedSearchResults,
    sortedSearchResults: store.appStore.completeSearchPage.sortedSearchResults,
    partnerConfig: store.appStore.config.partnerConfig,
    marketingCampaignsMap: store.appStore.completeSearchPage.marketingCampaignsMap,
    isTopPicksReady: store.appStore.completeSearchPage.isTopPicksReady,
    isLoading: store.appStore.completeSearchPage.searchResults.isLoading,
    isCompleted: store.appStore.completeSearchPage.searchResults.isCompleted,
    sort: store.appStore.completeSearchPage.sort,
    currentCurrency: store.appStore.currency.currentCurrency,
    selectedItinerary: store.appStore.completeSearchPage.selectedItinerary,
    firstNearByAirportItineraryId: store.appStore.completeSearchPage.firstNearByAirportItineraryId,
    isNearbyAirportInTopPicks: store.appStore.completeSearchPage.isNearbyAirportInTopPicks,
    hasNoResults: store.appStore.completeSearchPage.hasNoResults,
    selectedFareFamilyItinerary: store.appStore.completeSearchPage.selectedFareFamilyItinerary,
    $resources: store.appStore.$resources,
    pricingFilters: store.appStore.completeSearchPage.fareCalendar.pricingFilters,
    // actions
    selectItinerary: store.appStore.completeSearchPage.selectItinerary,
    resetFilters: store.appStore.completeSearchPage.filters.reset,
    toggleAirlineFilter: store.appStore.completeSearchPage.filters.airline.toggle,
    selectFareFamilyItinerary: store.appStore.completeSearchPage.selectFareFamilyItinerary,
    selectItineraryGroup: store.appStore.completeSearchPage.selectItineraryGroup,
  }));
};

export default useStateOfSearchResultList;
